import React from 'react';
import styled from 'styled-components';
import colors from 'utils/colors';
import map from 'lodash/map';
import { Button, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { deleteFile } from 'api/utils';
import { AppToaster } from 'components/AppToaster';

const UploadedAttachments = ({ attachments, fetchUploadedFiles, request }) => {
  return (
    attachments.length > 0 && (
      <Container>
        <H3>Attachments</H3>
        {map(attachments, (f, index) => (
          <Attachments key={index}>
            <Item>{f.displayName} </Item>
            <Button
              icon={IconNames.TRASH}
              color={colors.lightGray}
              style={{ cursor: 'pointer' }}
              onClick={() =>
                deleteFile(f.uploadID, 'QUESTIONNAIRE')
                  .then(res => {
                    try {
                      AppToaster.show({
                        message: res.data.message,
                        intent: Intent.SUCCESS,
                      });
                      fetchUploadedFiles(request.vendorRequestID);
                    } catch (err) {
                      console.error(err);
                    }
                  })
                  .catch(err => {
                    AppToaster.show({
                      message: err.response.data.message,
                      intent: Intent.DANGER,
                    });
                  })
              }
              minimal
            />
          </Attachments>
        ))}
      </Container>
    )
  );
};

const Container = styled.div`
  padding: 0.5rem 1rem;
  margin: 2rem;
  border-radius: 5px;
  border: 2pt solid ${colors.muted};
  width: max-content;
  height: 100%;
`;

const H3 = styled.h3`
  font-weight: 500;
  margin: 0.5rem;
  color: ${colors.muted};
`;

const Item = styled.span`
  padding-left: 5px;
`;

const Attachments = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
`;

export default UploadedAttachments;
